// @flow
import { get } from 'lodash';

import {
  CLEAR_ADDITIONAL_TRANSPORTS,
  SORT_ADDITIONAL_TRANSPORTS,
} from 'Store/booking/additional-transports/additionalTransports.action';
import { sorterByPrice, sorterByRecommendation } from './constants';

type State = Array<Sorter>;

const initialState: State = [{ ...sorterByRecommendation, selected: true }, sorterByPrice];

export default function sortersReducer(state: State = initialState, action: ?Action<*>): State {
  switch (get(action, 'type')) {
    case CLEAR_ADDITIONAL_TRANSPORTS:
      return initialState;

    case SORT_ADDITIONAL_TRANSPORTS:
      const selectedSorterId = get(action, 'payload.sorter.id');
      return state.map(sorter => ({
        ...sorter,
        selected: sorter.id === selectedSorterId,
      }));

    default:
      return state;
  }
}
